import { render, staticRenderFns } from "./PatientState.vue?vue&type=template&id=a83fa658&scoped=true"
import script from "./PatientState.vue?vue&type=script&lang=js"
export * from "./PatientState.vue?vue&type=script&lang=js"
import style0 from "./PatientState.vue?vue&type=style&index=0&id=a83fa658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83fa658",
  null
  
)

export default component.exports